const customTags = {
    event: "event",
    eventCategory: "eventCategory",
    eventAction: "eventAction",
    eventLabel: "eventLabel",
    petType: "pet_type",
    breedNames: "breed_names",
    petAge: "pet_age",
    planType: "plan_type",
    annualPayout: "annual_payout",
    annualDeductible: "annual_deductible",
    reimbursementAmount: "reimbursement_amount",
    coverageBeginsDate: "coverage_begins_date",
    preferredBillingCycle: "preferred_billing_cycle",
    donationAmount: "donation_amount",
    donationSubmitted: "donation_submitted",
    promoCode: "promo_code",
    phoneNumberClicked: "phone_number_clicked",
    userId: "user_id",
    ecommerce: "ecommerce",
    currencyCode: "currencyCode",
    checkout: "checkout",
    actionField: "actionField",
    step: "step",
    name: "name",
    id: "id",
    price: "price",
    brand: "brand",
    category: "category",
    variant: "variant",
    quantity: "quantity",
    dimension6: "dimension6",
    dimension8: "dimension8",
    dimension9: "dimension9",
    dimension10: "dimension10",
    dimension11: "dimension11",
    dimension53: "dimension53",
    affiliation: "affiliation",
    revenue: "revenue",
    tax: "tax",
    shipping: "shipping",
    coupon: "coupon",
    errorMessage: "errorMessage",
    products: "products",
    purchase: "purchase",
    pageType: "page_type",
    pageTitle: "page_title",
    callNumber: "call_number",
    callDuration: "call_duration",
    newOrReturningCall: "new_or_returning_call",
    callPageUrl: "call_page_url",
    callLocation: "call_location",
    cartLineItemId: "cart_line_item_id",
    testVersion: "test_version",
    petName: "pet_name",
    email: "email",
    zipCode: "postal_code",
    firstName: "first_name",
    lastName: "last_name",
    homeAddress: "home_address",
    street: "street",
    city: "city",
    region: "region",
    country: "country",
    phoneNumber: "phone_number",
    existingCustomer: "existingCustomer",
    reportId: "report_id",
    wellnessAdded: "wellnessAdded",
    wellnessPlanSelected: "wellnessPlanSelected",
    wellnessPlanPremium: "wellnessPlanPremium",
    enhancedConversionData: "enhanced_conversion_data",
    failure_reason: "failure_reason",
    pet_age: "pet_age",
    pet_type: "pet_type",
};

export default customTags;
